
import * as types from "../types/posTerminals"

export const addNewPosTerminal = (newPosTerminal, accountId) => ({
  type: types.ADD_POS_TERMINAL,
  newPosTerminal,
  accountId
})

export const editPosTerminal = (posTerminal, accountId) => ({
  type: types.EDIT_POS_TERMINAL,
  posTerminal,
  accountId
})

export const removePosTerminal = (posTerminalId, accountId) => ({
  type: types.DELETE_POS_TERMINAL,
  posTerminalId,
  accountId
})